import { MatCardModule } from '@angular/material/card';
import {
  MAT_RIPPLE_GLOBAL_OPTIONS,
  MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';

/**
 * providers
 * @type {({provide: InjectionToken<RippleGlobalOptions>; useValue: {disabled: boolean}} | {provide: InjectionToken<LabelOptions>; useValue: {float: string}})[]}
 */
export const providers: any[] = [
  { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { float: 'never' } },
  // {
  //   provide: DateAdapter,
  //   useClass: MomentDateAdapter,
  //   deps: [MAT_DATE_LOCALE],
  // },
  // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  MatDatepickerModule,
];
/**
 * modules
 * @type {(MatCardModule | MatDialogModule | MatExpansionModule | MatFormFieldModule | MatIconModule | MatInputModule | MatListModule | MatPaginatorModule | MatSortModule | MatSelectModule | MatStepperModule | MatTableModule | MatTooltipModule | MatSidenavModule | MatCheckboxModule | MatTabsModule | MatRadioModule)[]}
 */
export const modules: any[] = [
  MatCardModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
  MatSortModule,
  MatSelectModule,
  MatTabsModule,
  MatRadioModule,
  MatSidenavModule,
  MatDatepickerModule,
  MatNativeDateModule,
];
